module.exports = __webpack_public_path__ + "static/media/Tribal Chief.02102fb9.jpg";